<section style="text-align: center">
  <h3>{{ 'ERROR' | transloco }} :</h3>
  <p>{{ data.message }}</p>

  <div style="display: flex; justify-content: center; margin-top: 25px">
    <a mat-button class="bt-button dark" (click)="close()">{{ 'CLOSE' | transloco }}</a>
  </div>
</section>
